export default "__VITE_ASSET__94ca7a09__"